import { Image } from '@belong/ui';

export const AppGIF = () => (
  <div className="sm:justifiy-start relative flex flex-col items-center sm:flex-row sm:items-start">
    <Image
      alt="phone-frame"
      className="z-[1] h-[390px] w-[190px] overflow-hidden"
      src="app/phone-frame.png"
    />
    <div className="absolute top-[9px] w-[172px] sm:left-[9px] sm:w-auto">
      <Image
        alt="app-demo"
        className="h-[372px] w-[172px]"
        src="app/demo.gif"
      />
    </div>
  </div>
);
